<template>
  <div id="app" class="app">
    <div>
      <Header />
    </div>
    <div class="page-center">
      <router-view />
    </div>
    <Footer />
    <div class="logintip d-flex a-center j-center" v-if="$store.state.showLoginTip">
      <div class="apploginbox">
        <img class="closeico" @click="closeLoginTip" src="@/assets/img/close.png" />
        <Login />
      </div>
    </div>
    <div class="logintip d-flex a-center j-center" v-if="$store.state.showChangePassword">
      <div class="apploginbox">
        <img class="closeico" @click="closeChangePassword" src="@/assets/img/close.png" />
        <ChangePassword />
      </div>
    </div>
  </div>
</template>

<script>
import Header from './components/header/index.vue'
import Footer from './components/footer/index.vue'
import Login from './components/login/login.vue'
import ChangePassword from './components/ChangePassword/index.vue'
export default {
  name: 'App',
  components: {
    Header,
    Footer,
    Login,
    ChangePassword
  },
  methods: {
    closeLoginTip() {
      this.$store.commit('setLoginTip',false)
    },
    closeChangePassword() {
      this.$store.commit('setChangePassword',false)
    }
  }
}
</script>

<style lang="scss">
.app{
  min-height: 100%;
  position: relative;
}
.page-center{
  min-height: calc(100vh - 200px);
  box-sizing: border-box;
  background: #f6f6f6;
  padding: 1px 0 233px;
}
.logintip{
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0,0,0,0.5);
  .apploginbox{
    padding: 1.25rem 1.875rem;
    border-radius: 0.3125rem;
    background: #FFFFFF;
    position: relative;
  }
  .closeico{
    width: 1.25rem;
    height: 1.25rem;
    position: absolute;
    right: 0.625rem;
    top: 0.625rem;
    cursor: pointer;
  }
}
*{
  margin: 0;
  padding: 0;
  list-style: none;
}
html{
  font-size: 16px;
  min-width: 75rem;
}
button{
  outline: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
}
input{
  background: none;
  border: none;
  width: 100%;
  box-sizing: border-box;
  font-size: 16px;
}
img{
  margin: 0;
  padding: 0;
  font-size: 0;
}
</style>
